<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    placement="right"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- 定价类型 -->
      <a-form-model-item label="定价类型" prop="pricingType">
        <a-radio-group button-style="solid" v-model="form.pricingType">
          <a-radio-button :value="0">固定</a-radio-button>
          <a-radio-button :value="1">自定义</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <!-- 状态 -->
      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1">启用</a-radio-button>
          <a-radio-button :value="0">禁用</a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <!-- 固定价格 -->
      <a-form-model-item label="固定价格" prop="price" v-if="form.pricingType === 0">
        <a-input v-model="form.price" placeholder="请输入" :maxLength="10" />
      </a-form-model-item>

      <!-- 自定义价格 -->
      <a-form-model-item label="最小定价" prop="priceMin" v-if="form.pricingType === 1">
        <a-input v-model="form.priceMin" placeholder="请输入" :maxLength="10" />
      </a-form-model-item>
      <a-form-model-item label="最高定价" prop="priceMax" v-if="form.pricingType === 1">
        <a-input v-model="form.priceMax" placeholder="请输入" :maxLength="10" />
      </a-form-model-item>

      <!-- 服务标识 -->
      <a-form-model-item label="服务标识" prop="serviceItemId">
        <a-select v-model="form.serviceItemId" placeholder="请选择服务" allow-clear style="width: 100%">
          <a-select-option v-for="s in serviceOptions" :key="s.id" :value="s.id">
            {{ s.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 产品SKU标识 -->
      <!-- <a-form-model-item label="产品SKU标识" prop="prodSkuId">
        <a-select v-model="form.prodSkuId" placeholder="请选择SKU" allow-clear style="width:100%">
          <a-select-option v-for="k in skuOptions" :key="k.id" :value="k.id">
            {{ k.prodName }}
          </a-select-option>
        </a-select>
      </a-form-model-item> -->

      <!-- 排序 -->
      <a-form-model-item label="排序号" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>

      <!-- 按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getObj, addObj, putObj } from '@/api/maintenance/servicePricing'
import { fetchList as fetchService } from '@/api/maintenance/serviceItem'
import { fetchList as fetchSku } from '@/api/maintenance/product'

export default {
  name: 'ServicePricingCreateForm',
  props: {

  },
  data() {
    return {
      open: false,
      submitLoading: false,
      formTitle: '',
      serviceOptions: [],
      skuOptions: [],
      form: {
        prodSkuId: undefined,
        serviceItemId: undefined,
        pricingType: 0,
        price: 0,
        priceMin: 0,
        priceMax: 0,
        sort: 99,
        status: 1,
      },
      rules: {
        pricingType: [{ required: true, message: '请选择定价类型', trigger: 'change' }],
        price: [
          { required: true, message: '请输入固定价格', trigger: 'blur' },
          { pattern: /^\d+(\.\d{1,2})?$/, message: '固定价格须为数字，最多两位小数', trigger: 'blur' },
        ],
        priceMin: [
          {
            validator: (_, v, cb) => {
              if (this.form.pricingType !== 1) return cb()
              if (v === '' || v == null) return cb(new Error('请输入最小定价'))
              if (!/^\d+(\.\d{1,2})?$/.test(v)) return cb(new Error('最小定价须为数字，最多两位小数'))
              if (Number(v) >= Number(this.form.priceMax)) return cb(new Error('最小定价必须小于最高定价'))
              cb()
            },
            trigger: ['blur', 'change'],
          },
        ],
        priceMax: [
          {
            validator: (_, v, cb) => {
              if (this.form.pricingType !== 1) return cb()
              if (v === '' || v == null) return cb(new Error('请输入最高定价'))
              if (!/^\d+(\.\d{1,2})?$/.test(v)) return cb(new Error('最高定价须为数字，最多两位小数'))
              if (Number(v) <= Number(this.form.priceMin)) return cb(new Error('最高定价必须大于最小定价'))
              cb()
            },
            trigger: ['blur', 'change'],
          },
        ],
        serviceItemId: [{ required: true, message: '请选择服务标识', trigger: 'change' }],
        prodSkuId: [{ required: true, message: '请选择产品SKU标识', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序号', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
    }
  },
  created() {
    this.loadService()
    this.loadSku()
  },
  methods: {
    /* 对外暴露：新增 */
    handleAdd(prodSkuId) {
      this.reset()
      this.form.prodSkuId = prodSkuId
      this.open = true
      this.formTitle = '新增维修产品服务项'
    },
    /* 对外暴露：修改 */
    handleUpdate(row) {
      this.reset()
      getObj({ prodSkuId: row.prodSkuId, serviceItemId: row.serviceItemId }).then((res) => {
        this.form = res.data
        this.open = true
        this.formTitle = '修改维修产品服务项'
      })
    },
    /* 关闭前确认 */
    onCloseConfirm(done) {
      this.$confirm({ content: '数据未保存，确定关闭？', onOk: done })
    },
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },
    reset() {
      this.form = {
        prodSkuId: undefined,
        serviceItemId: undefined,
        pricingType: 0,
        price: 0,
        priceMin: 0,
        priceMax: 0,
        sort: 99,
        status: 1,
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitLoading = true
        const api = this.form.id ? putObj : addObj
        api(this.form)
          .then(() => {
            this.$message.success(this.form.id ? '修改成功' : '新增成功')
            this.open = false
            this.$emit('ok')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },
    /* 加载服务下拉 */
    loadService() {
      fetchService({ pageNum: 1, pageSize: 999 }).then((res) => {
        this.serviceOptions = res.data.records
      })
    },
    /* 加载SKU下拉 */
    loadSku() {
      fetchSku({ pageNum: 1, pageSize: 999 }).then((res) => {
        this.skuOptions = res.data.records
      })
    },
  },
}
</script>
